var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable */
import React, { useEffect, useState } from 'react';
import get from 'lodash/get';
import CloseIcon from '@mui/icons-material/Close';
import classNames from 'classnames';
import { Events, JourneysSelectors, TrackingActions, useAppDispatch, useAppSelector, } from 'conversional-journey';
import { createComponentsFromObject, InlineSVGRenderer } from 'conversional-components';
import { sendToHost } from 'conversional-iframe-communication';
import { getItem, setItem } from 'conversional-persistent-storage';
import { ComponentClass } from 'conversional-theme';
import { LAUNCHER } from './General.styles';
import { getStyles } from './Launcher.styles';
var HIDE_STORAGE_KEY = 'launcher-hidden';
/**
 * Launcher View
 * The draft view for enabling the launcher to be added using
 * our recursive component builder
 */
var Launcher = function (_a) {
    var content = _a.content, onApplyStyles = _a.onApplyStyles, iframeStyles = _a.iframeStyles, bodyStyles = _a.bodyStyles, closeButtonStyles = _a.closeButtonStyles, closeButtonSvgStyles = _a.closeButtonSvgStyles, _b = _a.closable, closable = _b === void 0 ? false : _b, closeIcon = _a.closeIcon;
    var _c = useState(!!getItem(HIDE_STORAGE_KEY)), hidden = _c[0], setHidden = _c[1];
    var theme = useAppSelector(JourneysSelectors.selectTheme);
    var dispatch = useAppDispatch();
    var trackEvent = function (event) { return dispatch(TrackingActions.event(event)); };
    var classes = getStyles(theme);
    var complexLauncherStyles = get(content, 'Window.iframeStyles', {});
    var combinedStyles = iframeStyles
        ? __assign(__assign({}, iframeStyles), complexLauncherStyles) : __assign(__assign({}, LAUNCHER), complexLauncherStyles);
    useEffect(function () {
        sendToHost.styleIframe(combinedStyles, true);
        bodyStyles && sendToHost.styleParentBody(bodyStyles);
        onApplyStyles();
    }, []);
    var onClose = function (e) {
        e.preventDefault();
        e.stopPropagation();
        setHidden(true);
        trackEvent(Events.LAUNCHER_CLOSE);
        setItem(HIDE_STORAGE_KEY, '1');
        sendToHost.styleIframe({ display: 'none' }, true);
    };
    if (hidden)
        return null;
    return (_jsxs("div", { children: [closable &&
                (closeIcon ? (_jsx("span", { onClick: onClose, className: classNames(classes.closeButton, ComponentClass(closeButtonStyles)), children: _jsx(InlineSVGRenderer, { svgClassName: ComponentClass(closeButtonSvgStyles), alt: '', svgSrc: closeIcon }) })) : (_jsx(CloseIcon, { onClick: onClose, className: classNames(classes.closeButton, ComponentClass(closeButtonStyles)) }))), content &&
                createComponentsFromObject({
                    root: content || {},
                })] }));
};
export default Launcher;
